import React from "react";

import { MultiSelectValueProps } from "@mantine/core";

export const MultiSelectValue: React.FC<MultiSelectValueProps> = ({ label, ...rest }) => {
  const { classNames, onRemove, ...domProps } = rest;

  return <div className={domProps.className}>{label}</div>;
};
